import * as React from 'react';

import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { IconSearch } from '@lightspeed/flame/Icon/Search';
import { Input } from '@lightspeed/flame/Input';

// From @lightspeed/cirrus-table TableActions.SearchBar
const FlexButton = styled(Flex)`
  margin-left: -3px;
  > :first-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
// From @lightspeed/cirrus-table TableActions.SearchBar
export const SearchInputFlex = styled(Flex)`
  flex: 1;
  input[type='search'] {
    -webkit-appearance: textfield;
  }
  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
`;

interface Props {
  disabled?: boolean;
  onSearch?: (term: string) => void;
}
const SearchBar: React.FC<Props> = ({ disabled, onSearch }) => {
  const [searchInput, setSearchInput] = React.useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (onSearch) {
        onSearch(searchInput);
      }
    }
  };
  const handleClick = () => {
    if (onSearch) {
      onSearch(searchInput);
    }
  };

  React.useEffect(() => {
    if (searchInput === '' && onSearch) {
      onSearch('');
    }
  }, [searchInput, onSearch]);

  return (
    <Flex flex="1" className="cr-table-search-bar-form">
      <SearchInputFlex>
        <Input
          type="search"
          prefix={<IconSearch name="search" color="disabled" />}
          value={searchInput}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          placeholder="Search in results..."
          disabled={disabled}
          data-test="searchInput"
        />
      </SearchInputFlex>
      <FlexButton>
        <Button
          type="button"
          variant="secondary"
          fill={true}
          onClick={handleClick}
          disabled={disabled}
        >
          Search
        </Button>
      </FlexButton>
    </Flex>
  );
};

export { SearchBar };
